export default __webpack_public_path__ + "static/media/hamburger.d9f048f6.svg";